import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import SEOHead from '../../components/SEOHead';

export default function VertiixPage() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Vertiix Digital Factory",
    "description": "Vertiix è infrastruttura, non un fornitore. Digital Factory che costruisce il sistema operativo della crescita: produzione coordinata, flusso continuo, controllo totale e continuità operativa per aziende che vogliono governare la crescita.",
    "provider": {
      "@type": "Organization",
      "name": "Vertiix",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`
    },
    "serviceType": "Digital Factory",
    "areaServed": "IT"
  };

  return (
    <div className="bg-white text-gray-900">
      <SEOHead 
        title="Cos'è Vertiix - Digital Factory e Infrastruttura"
        description="Vertiix è infrastruttura, non un fornitore. Digital Factory che costruisce il sistema operativo della crescita: produzione coordinata, flusso continuo, controllo totale e continuità operativa per aziende che vogliono governare la crescita."
        keywords="digital factory, sistema operativo crescita, infrastruttura digitale, produzione governata, architettura scalabile, vertiix"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/vertiix`}
        ogImage="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/26134a7c97c7b6c8adda3aad56072f90.png"
        schema={schema}
      />
      
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-4 md:py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/26134a7c97c7b6c8adda3aad56072f90.png" 
              alt="Vertiix" 
              className="h-16 md:h-24"
            />
          </Link>
          
          {/* Mobile Menu Button */}
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          >
            <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${scrolled ? 'text-gray-700' : 'text-gray-600'}`}></i>
          </button>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8 lg:gap-12">
            <Link to="/" className={`text-sm tracking-wide transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#14B8A6]' : 'text-gray-600 hover:text-[#14B8A6]'}`}>
              Home
            </Link>
            <Link to="/problema" className={`text-sm tracking-wide transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#14B8A6]' : 'text-gray-600 hover:text-[#14B8A6]'}`}>
              Il Problema
            </Link>
            <Link to="/vertiix" className={`text-sm tracking-wide transition-colors whitespace-nowrap ${scrolled ? 'text-[#14B8A6] font-medium' : 'text-[#14B8A6] font-medium'}`}>
              Cos'è Vertiix
            </Link>
            <Link to="/come-funziona" className={`text-sm tracking-wide transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#14B8A6]' : 'text-gray-600 hover:text-[#14B8A6]'}`}>
              Come Funziona
            </Link>
            <Link to="/accesso" className={`text-sm tracking-wide transition-colors whitespace-nowrap ${scrolled ? 'text-gray-700 hover:text-[#14B8A6]' : 'text-gray-600 hover:text-[#14B8A6]'}`}>
              Come Si Accede
            </Link>
            <Link to="/valutazione" className={`px-6 py-3 border border-[#14B8A6] text-[#14B8A6] hover:bg-[#14B8A6] hover:text-white transition-all whitespace-nowrap cursor-pointer`}>
              VALUTAZIONE
            </Link>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
            <div className="px-6 py-4 space-y-4">
              <Link to="/" className="block text-sm text-gray-700 hover:text-[#14B8A6] transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Home
              </Link>
              <Link to="/problema" className="block text-sm text-gray-700 hover:text-[#14B8A6] transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Il Problema
              </Link>
              <Link to="/vertiix" className="block text-sm text-[#14B8A6] font-medium transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Cos'è Vertiix
              </Link>
              <Link to="/come-funziona" className="block text-sm text-gray-700 hover:text-[#14B8A6] transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Come Funziona
              </Link>
              <Link to="/accesso" className="block text-sm text-gray-700 hover:text-[#14B8A6] transition-colors py-2" onClick={() => setMobileMenuOpen(false)}>
                Come Si Accede
              </Link>
              <Link to="/valutazione" className="block text-center px-6 py-3 border border-[#14B8A6] text-[#14B8A6] hover:bg-[#14B8A6] hover:text-white transition-all whitespace-nowrap cursor-pointer mt-4" onClick={() => setMobileMenuOpen(false)}>
                VALUTAZIONE
              </Link>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Definition */}
      <section className="min-h-screen flex items-center bg-gradient-to-br from-[#f0fdf9] via-white to-[#f0fdf9] pt-24 md:pt-32 px-6 md:px-12">
        <div className="max-w-[1400px] mx-auto w-full">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center">
            <div className="lg:col-span-5">
              <div className="text-xs uppercase tracking-[1px] text-[#14B8A6] mb-4">Digital Factory</div>
              <h1 className="text-4xl md:text-5xl lg:text-[56px] font-serif font-medium leading-[1.15] mb-6 md:mb-8 text-gray-900">
                Vertiix È<br/>Infrastruttura
              </h1>
              <p className="text-base md:text-lg text-gray-600 leading-relaxed">
                Non un fornitore aggiuntivo. Non un'agenzia. Non un consulente. Vertiix è il sistema operativo che governa la crescita aziendale.
              </p>
            </div>
            
            <div className="lg:col-span-7">
              <div className="w-full h-[400px] md:h-[500px] lg:h-[600px]">
                <img 
                  src="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/db4a63b6291a24f04eee2515bcfc7def.png" 
                  alt="Sistema Vertiix" 
                  className="w-full h-full object-cover border border-gray-200"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Distinzione Categoriale */}
      <section className="bg-[#f8faf9] py-16 md:py-24 lg:py-32 px-6 md:px-12">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 lg:gap-16">
            
            {/* Non Siamo */}
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-gray-600 mb-8 md:mb-12">Non Siamo</h2>
              <ul className="space-y-4 md:space-y-6">
                <li className="flex items-start gap-3 md:gap-4 text-sm md:text-base text-gray-600">
                  <span className="text-red-500 text-lg md:text-xl flex-shrink-0">×</span>
                  <span>Agenzia di marketing</span>
                </li>
                <li className="flex items-start gap-3 md:gap-4 text-sm md:text-base text-gray-600">
                  <span className="text-red-500 text-lg md:text-xl flex-shrink-0">×</span>
                  <span>Consulenza strategica</span>
                </li>
                <li className="flex items-start gap-3 md:gap-4 text-sm md:text-base text-gray-600">
                  <span className="text-red-500 text-lg md:text-xl flex-shrink-0">×</span>
                  <span>Fornitore di servizi isolati</span>
                </li>
                <li className="flex items-start gap-3 md:gap-4 text-sm md:text-base text-gray-600">
                  <span className="text-red-500 text-lg md:text-xl flex-shrink-0">×</span>
                  <span>Partner tecnologico</span>
                </li>
                <li className="flex items-start gap-3 md:gap-4 text-sm md:text-base text-gray-600">
                  <span className="text-red-500 text-lg md:text-xl flex-shrink-0">×</span>
                  <span>Outsourcing operativo</span>
                </li>
              </ul>
            </div>

            {/* Spazio Vuoto */}
            <div className="hidden md:flex items-center justify-center relative">
              <div className="absolute inset-y-0 left-1/2 w-px bg-gray-300 border-l-2 border-dashed border-gray-300"></div>
              <div className="text-4xl md:text-6xl text-gray-300 opacity-50 relative z-10">≠</div>
            </div>

            {/* Siamo */}
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-8 md:mb-12">Siamo</h2>
              <ul className="space-y-4 md:space-y-6">
                <li className="flex items-start gap-3 md:gap-4 text-sm md:text-base text-gray-900">
                  <span className="text-[#14B8A6] text-lg md:text-xl flex-shrink-0">→</span>
                  <span>Digital Factory</span>
                </li>
                <li className="flex items-start gap-3 md:gap-4 text-sm md:text-base text-gray-900">
                  <span className="text-[#14B8A6] text-lg md:text-xl flex-shrink-0">→</span>
                  <span>Sistema operativo della crescita</span>
                </li>
                <li className="flex items-start gap-3 md:gap-4 text-sm md:text-base text-gray-900">
                  <span className="text-[#14B8A6] text-lg md:text-xl flex-shrink-0">→</span>
                  <span>Infrastruttura di regia</span>
                </li>
                <li className="flex items-start gap-3 md:gap-4 text-sm md:text-base text-gray-900">
                  <span className="text-[#14B8A6] text-lg md:text-xl flex-shrink-0">→</span>
                  <span>Produzione governata</span>
                </li>
                <li className="flex items-start gap-3 md:gap-4 text-sm md:text-base text-gray-900">
                  <span className="text-[#14B8A6] text-lg md:text-xl flex-shrink-0">→</span>
                  <span>Architettura scalabile</span>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </section>

      {/* Cosa Significa */}
      <section className="bg-white py-16 md:py-24 lg:py-32 px-6 md:px-12">
        <div className="max-w-[1400px] mx-auto">
          <div className="max-w-[900px] mx-auto">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium mb-12 md:mb-16 text-gray-900 text-center">
              Cosa Significa Digital Factory
            </h2>
            
            <div className="space-y-12 md:space-y-16">
              <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 items-center">
                <div className="md:col-span-7">
                  <h3 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 text-gray-900">Produzione</h3>
                  <p className="text-sm md:text-base leading-[1.8] text-gray-600">
                    Una factory produce.
Non esegue task isolati.

Vertiix costruisce asset, flussi, automazioni, contenuti e campagne come parti di un unico sistema.
Tutto è coordinato. Tutto è governato.
Non attività scollegate, ma infrastruttura produttiva.
                  </p>
                </div>
                <div className="md:col-span-5">
                  <div className="w-full h-[180px] md:h-[200px]">
                    <img 
                      src="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/da08a8aedfae2cb25ad961444b056045.png" 
                      alt="Produzione" 
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 items-center">
                <div className="md:col-span-5 md:order-2">
                  <div className="w-full h-[180px] md:h-[200px]">
                    <img 
                      src="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/f626551552415f2928f4d09a56b0e6ef.png" 
                      alt="Flusso" 
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <div className="md:col-span-7 md:order-1">
                  <h3 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 text-gray-900">Flusso</h3>
                  <p className="text-sm md:text-base leading-[1.8] text-gray-600">
                    Una factory ha un flusso.
Ogni elemento alimenta il successivo.

Lead, nurturing, conversione, retention ed espansione non sono fasi separate.
Sono parti di un unico sistema.
Nessun elemento è isolato.
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 items-center">
                <div className="md:col-span-7">
                  <h3 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 text-gray-900">Controllo</h3>
                  <p className="text-sm md:text-base leading-[1.8] text-gray-600">
                    Una factory ha controllo.
Ogni metrica è leggibile.
Ogni decisione è informata.

Nessuna opinione.
Nessuna scommessa.
Solo lettura chiara del sistema e interventi basati su dati unificati.
                  </p>
                </div>
                <div className="md:col-span-5">
                  <div className="w-full h-[180px] md:h-[200px]">
                    <img 
                      src="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/e5236d8e1f6b0d0c46acc7b9eb9ab625.png" 
                      alt="Controllo" 
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 items-center">
                <div className="md:col-span-5 md:order-2">
                  <div className="w-full h-[180px] md:h-[200px]">
                    <img 
                      src="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/c02a1e1c8c5ee866ac1ba84d3b94be3a.png" 
                      alt="Continuità" 
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <div className="md:col-span-7 md:order-1">
                  <h3 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 text-gray-900">Continuità</h3>
                  <p className="text-sm md:text-base leading-[1.8] text-gray-600">
                    Una factory non si ferma.
Non dipende da singole persone.
Non si blocca quando qualcuno cambia.

L’infrastruttura continua a produrre.
Il sistema continua a funzionare.
La crescita resta governabile.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-[#f8faf9] py-16 md:py-24 lg:py-32 px-6 md:px-12">
        <div className="max-w-[1400px] mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-serif font-medium mb-6 md:mb-8 text-gray-900">
            Vertiix non è per tutti.
          </h2>
          <p className="text-lg md:text-xl text-gray-600 mb-8 md:mb-12 max-w-[720px] mx-auto leading-relaxed">
            Lavoriamo solo con aziende che comprendono la differenza tra fare attività e governare un sistema. Se cerchi un fornitore, non siamo la scelta giusta.
          </p>
          <Link 
            to="/come-funziona" 
            className="inline-block px-8 md:px-12 py-3 md:py-4 bg-[#14B8A6] text-white text-xs tracking-[0.5px] uppercase hover:bg-[#0d9488] transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Scopri Come Funziona
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1a2332] py-16 md:py-20 px-6 md:px-12">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 mb-12">
            <div className="md:col-span-4">
              <img 
                src="https://static.readdy.ai/image/13db46b7263df02cb6f1b0f3fc2a6341/26134a7c97c7b6c8adda3aad56072f90.png" 
                alt="Vertiix" 
                className="h-48 mb-8"
                style={{ filter: 'drop-shadow(0 0 15px rgba(255, 255, 255, 0.6)) drop-shadow(0 0 30px rgba(255, 255, 255, 0.4)) drop-shadow(0 0 45px rgba(255, 255, 255, 0.3))' }}
              />
              <p className="text-sm text-gray-400 leading-relaxed">Digital Factory per aziende che vogliono governare la crescita, non subirla.</p>
            </div>
            
            <div className="md:col-span-2">
              <h4 className="text-sm font-semibold text-white mb-6">Navigazione</h4>
              <nav className="space-y-3">
                <Link to="/" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Home</Link>
                <Link to="/problema" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Il Problema</Link>
                <Link to="/vertiix" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Cos'è Vertiix</Link>
                <Link to="/come-funziona" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Come Funziona</Link>
                <Link to="/accesso" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">Come Si Accede</Link>
              </nav>
            </div>
            
            <div className="md:col-span-3">
              <h4 className="text-sm font-semibold text-white mb-6">Contatti</h4>
              <p className="text-sm text-gray-400">info@vertiix.ch</p>
            </div>
            
            <div className="md:col-span-3">
              <h4 className="text-sm font-semibold text-white mb-6">Azione</h4>
              <Link to="/valutazione" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors mb-3">Valutazione</Link>
              <Link to="/about-vertiix" className="block text-sm text-gray-400 hover:text-[#14B8A6] transition-colors">About Vertiix</Link>
            </div>
          </div>
          
          <div className="pt-6 sm:pt-7 md:pt-8 border-t border-gray-700 flex flex-col md:flex-row justify-between items-center gap-3 sm:gap-4">
            <p className="text-[10px] sm:text-xs text-gray-500 text-center md:text-left">
              © 2025 Vertiix. Sistema operativo della crescita.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
              <a 
                href="https://ti.chregister.ch/cr-portal/auszug/auszug.xhtml?uid=CHE-410.417.125" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-[10px] sm:text-xs text-gray-500 hover:text-[#14B8A6] transition-colors cursor-pointer"
              >
                CHE-410.417.125
              </a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-[10px] sm:text-xs text-gray-500 hover:text-[#14B8A6] transition-colors">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}